import React from 'react';
import { Tag } from 'tdesign-react';
import Descriptions from '@/components/Descriptions';

export default function BasicInfo({ messageEventTime, row }) {
  return (
    <Descriptions title='基础信息' column={3} emptySuffix='-'>
      <Descriptions.Item label='Topic' value={row.topic} />
      <Descriptions.Item label='消息ID' value={row.fullMessageName} />
      <Descriptions.Item
        label='分区'
        value={
          row.partition === -1 ? (
            <Tag
              theme='warning'
              variant='light'
              style={{
                marginLeft: 10,
                color: '#F49D0B',
                background: 'rgba(244, 157, 11, 0.10)',
              }}
            >
              非分区
            </Tag>
          ) : (
            row.partition
          )
        }
      />
      <Descriptions.Item label='消息Key' value={row.messageKey} />
      <Descriptions.Item label='消息EventTime' type='dateMillionTime' value={messageEventTime} />
      <Descriptions.Item label='集群' value={row.clusterName} />
    </Descriptions>
  );
}
